import AuthService from "./AuthService";
import ApiService from "./ApiService";


class CalculatorService extends ApiService {
    constructor(authService) {
        super();

        this._authService = authService;
        this._categoriesUrl = '/calculator/categories';
        this._culturesUrl = '/calculator/cultures';
        this._initialUrl = '/calculator/initial';
        this._attributesUrl = '/calculator/attributes';
        this._resultsUrl = '/calculator/results';
        this._xlsUrl = '/calculator/export-xls'
    }
    getInitial(searchId) {
        return this.postResource(this._initialUrl, {id: searchId}, this.getLangHeader());
    }

    getCategories() {
        return this.postResource(this._categoriesUrl, {}, this.getLangHeader());
    }

    getCultures() {
        return this.postResource(this._culturesUrl, {}, this.getLangHeader());
    }

    getAttributes(params) {
        return this.postResource(this._attributesUrl, params, this.getLangHeader())
    }

    getResults(params) {
        return this.postResource(this._resultsUrl, params, this.getLangHeader());
    }

    getXlsFile(params) {
        return this.postResource(this._xlsUrl, params, this.getLangHeader(), true);
    }
}

const calculatorService = new CalculatorService(AuthService);
export default calculatorService;
